<template>
    <div>
      <Breadcrumbs main="matchTx.dashboard" title="hsCode.header" />
      <b-container fluid>
        <h2 class="mb-1 mt-4 f-w-600">{{ $t('hsCode.header') }}</h2>
        <div>
            <b-row>
              <b-col lg="5" class="my-1">
                <b-form-group
                  v-model="sortDirection"
                  :label="$t('matchTx.filterOn')"
                  :description= "$t('matchTx.uncheck')"
                  label-cols-sm="3"
                  label-align-sm="right"
                  label-size="lg"
                  class="mb-0"
                  v-slot="{ ariaDescribedby }"
                >
                  <b-form-checkbox-group
                    v-model="filterOn"
                    :aria-describedby="ariaDescribedby"
                    class="mt-1 text-info"
                    plain
                  >
                    <b-form-checkbox value="mn">{{ $t('hsCode.mainHS') }}</b-form-checkbox>
                    <b-form-checkbox value="id">{{ $t('hsCode.HS') }}</b-form-checkbox>
                    <b-form-checkbox value="dTH">{{ $t('hsCode.descTH') }}</b-form-checkbox>
                    <b-form-checkbox value="dEN">{{ $t('hsCode.descEN') }}</b-form-checkbox>     
                  </b-form-checkbox-group>
                </b-form-group>
                <b-form-group
                  :label="$t('hsCode.keyword')"
                  label-for="filter-input"
                  label-cols-sm="3"
                  label-align-sm="right"
                  label-size="lg"
                  class="mb-0"
                >
                  <b-input-group size="sm">
                    <b-form-input v-show="false"
                      id="filter-input"
                      v-model="filter"
                      type="search"
                      class="text-info"
                      style="font-size: 18px;"
                    ></b-form-input>
                    <b-form-input
                      id="filter-Search"
                      v-model="filterSearch"
                      type="text"
                      :placeholder="$t('matchTx.typeToSearch')"
                      class="text-info"
                      style="font-size: 18px;"
                    ></b-form-input>
                    <b-input-group-append>
                      <b-button class="mx-2" size="lg" variant="success" style="font-size: 20px;" @click="filter = filterSearch">
                        <feather type="search"></feather>
                        {{ $t('hsCode.filter') }}
                      </b-button>
                      <b-button size="md" variant="primary" :disabled="!filter" @click="clearFilterSearch">
                        {{ $t('matchTx.clear') }}
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>                
              </b-col>              
              <b-col lg="7" class="my-1">
                <div>
                  <h4> {{ $t('hsCode.tip') }}</h4>
                  <p class="ml-1"> {{ $t('hsCode.tip1') }}</p>
                  <p class="ml-1"> {{ $t('hsCode.tip2') }}</p>
                  <p class="ml-1"> {{ $t('hsCode.tip3') }}</p>
                </div>
              </b-col>
              <div>
                <p class="ml-3 mx-2 text-primary" style="font-size: 16px;" > {{ $t('hsCode.remark') }}</p>
              </div>
            </b-row>
          <b-table
            sticky-header
            head-variant="dark"
            show-empty
            bordered
            responsive
            sort-icon-left
            stacked="md"
            sort-by.sync="HS"
            sort-desc.sync= "false"
            :sort-direction="sortDirection"
            :filter="filter"
            :filter-included-fields="filterOn"
            :items="items"
            :fields="fields"
            :current-page="currentPage"
            :per-page="perPage"
            @filtered="onFiltered"
          >
            <template #empty>
                <h5>{{ $t('reuse.noRecord') }}</h5>
            </template>
            <template #cell(hs)="row" >
              <b-button v-show="!row.item.id.endsWith('-')" size="sm" @click="openModalHS4(row.item, row.index, $event.target )" variant="outline-dark" v-b-popover.hover.top="$t('hsCode.hsDetailsHover')">
                {{ row.item.id}}
              </b-button>
          </template>
          </b-table>
          <b-row>
            <div class="row col-sm-4 ">
              <b-col class="my-1 ml-3">
                <b-pagination
                  v-model="currentPage"
                  :total-rows="totalRows"
                  :per-page="perPage"
                  align="fill"
                  class="my-0"
                ></b-pagination>
              </b-col>   
              <b-col sm="3" md="6" class="my-1">
                <b-form-group
                  :label= "$t('require.perPage')"
                  label-for="per-page-select"
                  label-cols-sm="6"
                  label-cols-md="4"
                  label-cols-lg="3"
                  label-align-sm="right"
                  label-size="sm"
                  class="mb-0"
                >
                  <b-form-select
                    id="per-page-select"
                    v-model="perPage"
                    :options="pageOptions"
                  ></b-form-select>
                </b-form-group>
              </b-col>
            </div>
          </b-row>
          <b-modal id="hs4Modal" :title="$t('hsCode.hsDetails')" size="xl" ok-only @hide="resetModalHS4">
            <b-table
            sticky-header
            head-variant="dark"
            show-empty
            bordered
            responsive
            sort-icon-left
            stacked="md"
            :items="itemsHS4"
            :fields="fieldsHS4"
            :current-page="currentPageHS4"
            :per-page="perPageHS4"
          >
            <template #empty>
                <h5>{{ $t('reuse.noRecord') }}</h5>
            </template>
          </b-table>
          <b-row>
            <div class="row col-sm-10 ">
              <b-col class="my-1 ml-3">
                <b-pagination
                  v-model="currentPageHS4"
                  :total-rows="totalRowsHS4"
                  :per-page="perPageHS4"
                  align="fill"
                  class="my-0"
                ></b-pagination>
              </b-col>   
              <b-col sm="3" md="6" class="my-1">
                <b-form-group
                  :label= "$t('require.perPage')"
                  label-for="per-page-select"
                  label-cols-sm="6"
                  label-cols-md="4"
                  label-cols-lg="3"
                  label-align-sm="right"
                  label-size="sm"
                  class="mb-0"
                >
                  <b-form-select
                    id="per-page-select"
                    v-model="perPageHS4"
                    :options="pageOptionsHS4"
                  ></b-form-select>
                </b-form-group>
              </b-col>
            </div>
          </b-row>
          </b-modal>
        </div>
      </b-container>
    </div>
  </template>
  <script>
  
  import { getDataHS , getData} from "../../firebase"
    export default {
      name: 'hsCode',
      data() {
        return {
          compId : '',
          itemsHS4 : [],
          fieldsHS4: [     
            { key: 'id', label: this.$t('hsCode.HS'), sortable: true, variant: 'info',
              formatter: value => {
                return value.endsWith('-') ? null : value
            }},  
            { key: 'dTH', label: this.$t('hsCode.descTH'), variant: 'success',},     
            { key: 'dEN', label: this.$t('hsCode.descEN'), variant: 'warning'}, 
          ],
          totalRowsHS4: 1,
          currentPageHS4: 1,
          perPageHS4: 15,
          pageOptionsHS4: [5, 10, 15, 20,{ value: 100, text: "Show a lot" }],
          items: [],
          fields: [
            { key: 'mn', label: this.$t('hsCode.mainHS'), sortable: true, variant: 'primary'},  
            { key: 'hs', label: this.$t('hsCode.HS'), sortable: true, variant: 'info'},        
            // { key: 'id', label: this.$t('hsCode.HS'), sortable: true, variant: 'info',
            //   formatter: value => {
            //     return value.endsWith('-') ? null : value
            // }},  
            { key: 'dTH', label: this.$t('hsCode.descTH'), variant: 'success',},     
            { key: 'dEN', label: this.$t('hsCode.descEN'), variant: 'warning'}, 
          ],
          totalRows: 1,             
          currentPage: 1,
          perPage: 15,
          pageOptions: [5, 10, 15, 20,{ value: 100, text: "Show a lot" }],
          sortBy: 'HS',
          sortDesc: false,
          sortDirection: 'asc',
          filter: null,
          filterOn: [],
          filterSearch : ''
        }
      },

      mounted() {
        getDataHS("HSex",(res)=>{
          this.items = res 
          this.totalRows = res.length
        })
      },
      methods: {
        onFiltered(filteredItems) {
          // Trigger pagination to update the number of buttons/pages due to filtering
          this.totalRows = filteredItems.length
          this.currentPage = 1
        },
       handleFilterSearch(){
          this.filter = this.filterSearch
        },
        clearFilterSearch(){
          this.filter = ''
          this.filterSearch = ''
        },
        async openModalHS4(item, index, button) {
          let id4 = item.id.slice(0,4)
          // let id4 = item.id
          await getData( 'HSex' ,'h4' , id4, (res)=>{
              this.itemsHS4 = res
              this.totalRowsHS4 = res.length
          })
          this.$root.$emit('bv::show::modal', "hs4Modal" , button)
        },
      resetModalHS4() {
        this.itemsHS4 = []
      },
      }
    }
  </script>
